import type { ReactNode } from 'react';
import { cx } from '../cx';

/** A titled block inside a template, with an id for contents links. Renders nothing without content. */
export function TemplateSection({
  id,
  title,
  eyebrow,
  description,
  action,
  spacing = 'md',
  children,
  className,
}: {
  id?: string;
  title?: ReactNode;
  /** A small label above the title ("Guides and reports"). */
  eyebrow?: ReactNode;
  /** One or two sentences under the title. */
  description?: ReactNode;
  /** A "See all" style link beside the title. */
  action?: ReactNode;
  /** Space between the heading and the content: `md` (16px, default) or `lg` (jc-block, the landing page). */
  spacing?: 'md' | 'lg';
  children?: ReactNode;
  className?: string;
}) {
  if (children == null || children === false) return null;
  return (
    <section
      id={id}
      aria-labelledby={id && title ? `${id}-title` : undefined}
      className={cx('flex scroll-mt-24 flex-col', spacing === 'lg' ? 'gap-jc-block' : 'gap-4', className)}
    >
      {title ? (
        <div className="flex items-end justify-between gap-4">
          <div className="flex min-w-0 flex-col gap-1">
            {eyebrow ? <span className="type-eyebrow text-jc-ink-secondary">{eyebrow}</span> : null}
            <h2 id={id ? `${id}-title` : undefined} className="type-title text-jc-ink">
              {title}
            </h2>
          </div>
          {action}
        </div>
      ) : null}
      {title && description ? <p className="max-w-2xl text-jc-ink-secondary">{description}</p> : null}
      {children}
    </section>
  );
}
